import './SectionHeader.scss';

import { Divider, Typography } from '@trackman/web-shared-components';

import { ReactComponent as RightIcon } from 'svg/ArrowRight.svg';

const SectionHeader = ({
  title,
  isOpen,
  isEnabled = true,
  onClick,
}: {
  title: string;
  isOpen: boolean;
  isEnabled?: boolean;
  onClick?: () => void;
}) => {
  return (
    <>
      <div className='SectionHeader-container' onClick={onClick}>
        <Typography variant='body bold' component='div'>
          {title}
        </Typography>
        {isEnabled && <RightIcon className={`SectionHeader-icon ${isOpen ? 'SectionHeader-icon-open' : ''}`} />}
      </div>
      <div style={{ padding: '0 16px' }}>
        <Divider />
      </div>
    </>
  );
};

export default SectionHeader;
